// OTP cooldown slice — remembers when each OTP was last successfully requested
// so the UI can block a resend for OTP_COOLDOWN_MS. Keyed per otpType + number
// (see otpKeys.ts). Deliberately its OWN slice, not a field on authSlice:
// clearAuth wipes that slice on logout, and surviving a logout is exactly the
// loophole this closes. Persisted via the root persist config, so the cooldown
// also survives a reload.

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { OTP_COOLDOWN_MS } from './otpKeys';

export interface OtpState {
  /** cooldown key → epoch ms of the last successful request */
  lastRequestedAt: Record<string, number>;
}

const initialState: OtpState = {
  lastRequestedAt: {},
};

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    /** A send succeeded — start (or restart) that key's cooldown. */
    otpRequested: (state, action: PayloadAction<{ key: string; at: number }>) => {
      const { key, at } = action.payload;
      // The map is persisted, so prune spent entries as we go instead of
      // letting old numbers accumulate in localStorage forever.
      for (const [k, stamped] of Object.entries(state.lastRequestedAt)) {
        if (at - stamped >= OTP_COOLDOWN_MS) delete state.lastRequestedAt[k];
      }
      state.lastRequestedAt[key] = at;
    },
  },
});

export const { otpRequested } = otpSlice.actions;
export default otpSlice;
